import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../Assets/css/inline-styles.css";
import moment from "moment";
import { FaCalendarAlt } from "react-icons/fa";

const WeekPicker = ({ setSelectedDates }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  const handleWeekChange = (date) => {
    if (date) {
      setSelectedDate(date);
      // const startOfWeek = moment(date).startOf("isoWeek").format("YYYY-MM-DD");
      // const endOfWeek = moment(date).endOf("isoWeek").format("YYYY-MM-DD");
      const startOfWeek = moment(date).startOf("week").format("YYYY-MM-DD"); // Sunday
      const endOfWeek = moment(date).endOf("week").format("YYYY-MM-DD"); // Saturday
      setSelectedDates({
        startOfWeek,
        endOfWeek,
      });
    } else {
      // Clear data when no date is selected
      setSelectedDate(null);
      setSelectedDates({
        startOfWeek: "",
        endOfWeek: "",
      });
    }
  };

  return (
    <div>
      <DatePicker
        selected={selectedDate}
        dateFormat="I/R"
        locale="en-GB"
        showWeekNumbers
        showWeekPicker
        onChange={handleWeekChange}
        className="form-control"
        placeholderText="Select Week"
        isClearable={true}
        customInput={
          <div className="datepicker-custom-input">
            <FaCalendarAlt className="datepicker-icon-color" />
            <input
              type="text"
              value={
                selectedDate
                  ? `Week ${moment(selectedDate).isoWeek()}, ${moment(
                      selectedDate
                    ).year()}`
                  : `Week ${moment().isoWeek()}, ${moment().year()}`
              }
              placeholder="Select Week"
              readOnly
              className="border-none-padding-left-10"
            />
          </div>
        }
      />
    </div>
  );
};

export default WeekPicker;
